export * from './topbar-lgpd'
